<div id="video-widget" class="video-widget-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="video-widget-content">
                    <div class="section-title text-left">
                        <h2 [innerHTML]="videoWidgetConfig.title | linebreaks"></h2>
                        <p [innerHTML]="videoWidgetConfig.description | linebreaks"></p>
                    </div>
                    <div class="mt-4">
                        <a [href]="videoWidgetConfig.buttonUrl" class="btn btn-primary rounded-pill px-4 py-2 rounded-pill-btn">
                            {{ videoWidgetConfig.buttonText }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="video-container">
                    <video #videoPlayer autoplay muted loop playsinline class="video-player">
                        <source [src]="videoWidgetConfig.videoUrl" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    </div>
</div>
